import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import { HeaderTab } from '../../components'
import { Terms, Questions } from './components'
import Loading from '../../components/atom/loading/Loading'

// constants
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'

// images
import CloseImg from '../../assets/image/close/ic-close-b.svg'

const UseGuide = () => {
  const { fetchData, loading, data, error } = useAxios()
  const location = useLocation()
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const [isTermAgree, setIsTermAgree] = useState(
    user?.agreementTermsYn === 'Y' ? true : false,
  )

  // 탭
  const [selectedTab, setSelectedTab] = useState(0)

  // 서비스
  const [serviceItem, setServiceItem] = useState({
    id: null,
    contents: null,
  })

  // 개인정보
  const [privacyItem, setPrivacyItem] = useState({
    id: null,
    contents: null,
  })

  // 개인정보
  const [ageItem, setAgeItem] = useState({
    id: null,
    contents: null,
  })

  // 서비스 드롭
  const [serviceDrop, setServiceDrop] = useState({
    id: [],
    date: [],
  })

  // 개인정보 드롭
  const [privacyDrop, setPrivacyDrop] = useState({
    id: [],
    date: [],
  })

  // 드롭다운
  const [termsDrop, setTermsDrop] = useState(null)

  // 이용약관 동의
  const [termsAgree, setTermsAgree] = useState({
    service: false, // 서비스 이용약관
    age: false, // 14세 이상 false
    privacy: true, // 개인 정보 수집 및 이용동의 default true값
    // 이전에 동의 완료
    complete: false,
    agreementTime: null,
  })

  // 선택
  const [activeTerms, setActiveTerms] = useState({
    service: false,
    age: false,
    privacy: false,
  })

  // 업데이트
  const [isUpdate, setIsUpdate] = useState(false)

  // 현재 선택일
  const [selectedDate, setSelectedDate] = useState(
    moment().format('YYYY-MM-DD'),
  )

  //  약관동의 데이터 조회
  useEffect(() => {
    getTermDetail()
  }, [])

  //
  function getTermInfo(data, termType) {
    const termInfo = data.find((e) => e.termsType === termType)

    return {
      id: termInfo?.termsIndex ?? null,
      contents: termInfo?.termsContents ?? null,
      isAgree: termInfo?.agreementYn === 'Y' ? true : false,
      agreementYn: termInfo?.agreementYn ?? 'N',
      date: termInfo?.termsDate ?? null,
      termsType: termInfo?.termsType ?? null,
    }
  }

  // [data]
  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData
    // console.log('약관data', data)
    if (resCode === TYPE.API_RESPONSE.SUCCESS) {
      if (resData) {
        if (resData.agreeTermsCnt > 0) {
          // 약관 동의로 변경되면 대시보드로 이동
          // const user = JSON.parse(localStorage.getItem('user'))

          //agreementTermsYn local storage 업데이트
          const userString = localStorage.getItem('user')
          const user = JSON.parse(userString)
          user.agreementTermsYn = 'Y'
          localStorage.setItem('user', JSON.stringify(user))

          // if (
          //   user?.agreementTermsYn !== 'Y' &&
          //   data?.resultData?.loginInfo?.agreementTermsYn === 'Y' &&
          //   isUpdate
          // ) {
          //   localStorage.setItem(
          //     'user',
          //     JSON.stringify(data?.resultData?.loginInfo),
          //   )
          navigate('/', { replace: true })
          // }
          // // 기존에도 동의 상태라면 로컬스토리지만 최신화
          // else {
          //   // 여기서 로컬스토리지가 초기화 됨(유저 정보 날라감)
          //   localStorage.setItem(
          //     'user',
          //     JSON.stringify(data?.resultData?.loginInfo),
          //   )
          // }
        } else {
          // console.log('location?.state?.agree', location?.state?.agree)
          // if (location?.state?.agree == 'N') {
          //   // let termDetailList = data.responseData.termDetailList
          //   let termsAgreeList = data.responseData.termsAgreeList // 최초 동의

          //   // type 별로 api 호출하기
          //   const serviceItem = getTermInfo(termsAgreeList, 'S')
          //   const privacyItem = getTermInfo(termsAgreeList, 'P')
          //   const ageItem = getTermInfo(termsAgreeList, 'A')

          //   setServiceItem(serviceItem)
          //   setPrivacyItem(privacyItem)
          //   setAgeItem(ageItem)
          // }

          if (user.agreementTermsYn === 'R') {
            // let termDetailList = data.responseData.termDetailList
            let termsReAgreeList = data.responseData.termsReAgreeList // 최초 동의

            // type 별로 api 호출하기
            const serviceItem = getTermInfo(termsReAgreeList, 'S')
            const privacyItem = getTermInfo(termsReAgreeList, 'P')
            // const ageItem = getTermInfo(termsReAgreeList, 'A')

            setServiceItem(serviceItem)
            setPrivacyItem(privacyItem)
            // setAgeItem(ageItem)
          }
          if (user.agreementTermsYn === 'N') {
            let termsAgreeList = data.responseData.termsAgreeList // 최초 동의

            // type 별로 api 호출하기
            const serviceItem = getTermInfo(termsAgreeList, 'S')
            const privacyItem = getTermInfo(termsAgreeList, 'P')
            const ageItem = getTermInfo(termsAgreeList, 'A')

            setServiceItem(serviceItem)
            setPrivacyItem(privacyItem)
            setAgeItem(ageItem)
          }
        }
      }
    } else {
      // navigate('/error')
      // console.log('error page')
    }

    /*
    // 응답 성공
    if (data && Array.isArray(data)) {
      // 디테일 응답 여부
      let isDetail = data.find((e) => e.contents)

      // 목록 조회
      if (!isDetail) {
        let dateList = Object.keys(data).map((item) => data[item].date)
        let formatDateList = dateList.map((item) =>
          moment(item).format('YYYY년 MM월 DD일 시행안'),
        )

        // setTermsDrop(dateList)
        setTermsDrop(formatDateList)
        setSelectedDate(data[0].date)
        getTermDetail(data[0].date)
      }
      // 상세 조회
      else if (isDetail) {
        const serviceItem = getTermInfo(data, '서비스이용약관')
        const privacyItem = getTermInfo(data, '개인정보처리방침')
        const ageItem = getTermInfo(data, '만 14세 이상 사용자')

        setServiceItem(serviceItem)
        setPrivacyItem(privacyItem)
        setAgeItem(ageItem)

        // setServiceItem({
        //   id:
        //     data.filter((e) => e.type === '서비스이용약관')[0]?.termId ?? null,
        //   contents:
        //     data.filter((e) => e.type === '서비스이용약관')[0]?.contents ??
        //     null,
        //   isAgree:
        //     data.filter((e) => e.type === '서비스이용약관')[0]?.agreementYn ===
        //     'Y',
        // })
        // setPrivacyItem({
        //   id:
        //     data.filter((e) => e.type === '개인정보처리방침')[0]?.termId ??
        //     null,
        //   contents:
        //     data.filter((e) => e.type === '개인정보처리방침')[0]?.contents ??
        //     null,
        //   isAgree:
        //     data.filter((e) => e.type === '개인정보처리방침')[0]
        //       ?.agreementYn === 'Y',
        // })
        // // HERE
        // setAgeItem({
        //   id:
        //     data.filter((e) => e.type === '만 14세 이상 사용자')[0]?.termId ??
        //     null,
        //   contents:
        //     data.filter((e) => e.type === '만 14세 이상 사용자')[0]?.contents ??
        //     null,
        //   agreementYn:
        //     data.filter((e) => e.type === '만 14세 이상 사용자')[0]
        //       ?.agreementYn ?? null,
        // })

        let isComplete =
          data.filter((item, idx) => item.agreementYn === 'Y').length ===
          data.length

        setTermsAgree({
          service: data[1]?.agreementYn === 'Y',
          privacy: true,
          complete: isComplete,
          age: data[2]?.agreementYn === 'Y', //default가 필수로 true
          agreementTime: data[0]?.agreementTime ?? data[1]?.agreementTime,
        })

        getLoginInfo()
      }
    }
    // 동의
    else if (data === 'success' || data === 'fail') {
      setIsUpdate(true)
      getTermDetail(selectedDate)
    }
    // 유저 정보
    else if (data?.resultData?.loginInfo) {
      // 약관 동의로 변경되면 대시보드로 이동
      if (
        user?.agreementTermsYn !== 'Y' &&
        data?.resultData?.loginInfo?.agreementTermsYn === 'Y' &&
        isUpdate
      ) {
        localStorage.setItem(
          'user',
          JSON.stringify(data?.resultData?.loginInfo),
        )
        navigate('/', { replace: true })
      }
      // 기존에도 동의 상태라면 로컬스토리지만 최신화
      else {
        // 여기서 로컬스토리지가 초기화 됨(유저 정보 날라감)
        // 주석 처리
        // localStorage.setItem(
        //   'user',
        //   JSON.stringify(data?.resultData?.loginInfo),
        // )
      }
    }
    */
  }, [data])

  // 약관동의 리스트 호출
  const getTermDetail = () => {
    // 최초 동의
    if (user && user.agreementTermsYn === 'N') {
      // id 안넣으면 최신으로 조회
      // const params = {
      //   ...(date && { date }),
      //   // ...(date && { date: moment(date).format('YYYY-MM-DD') }),
      // }
      fetchData(constants.API.TERM_AGREE_LIST, 'GET', null, null)
    }

    // 재동의
    if (user && user.agreementTermsYn === 'R') {
      fetchData(constants.API.TERM_REAGREE_LIST, 'GET', null, null)
    }
  }

  // 동의 버튼
  const submitTerms = (ids) => {
    // 미선택 체크
    if (ids.length === 0) {
      alert('약관 전체 동의가 필요합니다.')
      return
    }

    // 모두 선택 체크
    // 약관 개수(개인, 서비스 중 하나만 있는 경우 있음)
    let termCount = 0

    // 재동의(14세미만(ageItem A) 제외)
    if (location?.state?.agree === 'R') {
      if (serviceItem.id) termCount += 1
    } else {
      if (serviceItem.id) termCount += 1
      if (privacyItem.id) termCount += 1
      if (ageItem.id) termCount += 1
    }

    if (termCount !== ids.length) {
      alert('약관 전체 동의가 필요합니다.')
    } else {
      if (user) {
        const data = {
          termIds: ids,
        }
        fetchData(constants.API.TERM_AGREE, 'POST', data)
      }
    }
  }

  // 약관동의 제출버튼
  const handleAgree = () => {
    let targetId = []

    // 재동의
    if (location?.state?.agree === 'R') {
      // if (serviceItem.agreementYn == 'R') {
      // 서비스
      if (termsAgree.service && serviceItem?.id && !serviceItem?.isAgree) {
        targetId.push(serviceItem.id)
      }
    } else {
      // 서비스
      if (termsAgree.service && serviceItem?.id && !serviceItem?.isAgree) {
        targetId.push(serviceItem.id)
      }
      // 14세
      if (termsAgree.age && ageItem?.id && !ageItem?.isAgree) {
        targetId.push(ageItem.id)
      }

      // 개인
      if (termsAgree.privacy && privacyItem?.id && !privacyItem?.isAgree) {
        targetId.push(privacyItem.id)
      }
    }

    submitTerms(targetId)
  }

  // 체크 박스 핸들러
  const handleCheck = (flag) => {
    switch (flag) {
      // 전체
      case 0:
        if (location?.state?.agree === 'R') {
          setTermsAgree({
            service: !termsAgree.service,
            age: true,
            privacy: true,
          })
        } else {
          setTermsAgree({
            service: termsAgree.service && termsAgree.age ? false : true,
            age: termsAgree.service && termsAgree.age ? false : true,
            privacy: true,
          })
        }

        break

      // 서비스
      case 1:
        if (location?.state?.agree === 'R') {
          setTermsAgree({
            service: !termsAgree.service,
            age: true,
            privacy: true,
          })
        } else {
          setTermsAgree({
            ...termsAgree,
            service: !termsAgree.service,
          })
        }
        break

      // 만 14세 이상 사용자
      case 2:
        setTermsAgree({
          ...termsAgree,
          age: !termsAgree.age,
        })
        break

      // 개인정보
      case 3:
        setTermsAgree({
          ...termsAgree,
          privacy: termsAgree.privacy,
        })
        break

      default:
        break
    }
  }

  // 로그아웃
  const signOut = (e) => {
    e.preventDefault()
    fetchData(constants.API.SIGN_OUT, 'POST')
    localStorage.removeItem('user')
    localStorage.removeItem('isNewNotice')
    localStorage.removeItem('happyorderYn')
    localStorage.removeItem('closedDay')
    localStorage.removeItem('shopHoursStart')
    localStorage.removeItem('shopHoursEnd')
    localStorage.removeItem('sessionAlert')

    window.location.reload()

    setTimeout(() => {
      navigate('/signin', { replace: true })
    }, 500)
  }

  // 자세히보기 핸들러
  const handleArrow = (flag) => {
    switch (flag) {
      // 서비스
      case 0:
        setActiveTerms({
          ...activeTerms,
          service: !activeTerms.service,
        })

        break

      case 1:
        setActiveTerms({
          ...activeTerms,
          age: !activeTerms.age,
        })

        break

      // 개인정보
      case 2:
        setActiveTerms({
          ...activeTerms,
          privacy: !activeTerms.privacy,
        })

        break

      default:
        break
    }
  }

  // const handleDropdown = (flag, opt) => {
  //   let replaceDate = opt.replace(/시행안|년|월|일| |/g, '')
  //   let finDate = moment(replaceDate).format('YYYY-MM-DD')

  //   setActiveTerms({
  //     service: false,
  //     privacy: false,
  //   })
  //   setSelectedDate(finDate)

  //   switch (flag) {
  //     // 서비스
  //     case 0:
  //       // 기존
  //       // getTermDetail(TYPE.USE_GUIDE.SERVICE, serviceDrop.id[opt])

  //       // 변경
  //       getTermDetail(finDate)

  //       break

  //     // 개인정보
  //     case 1:
  //       // 기존
  //       // getTermDetail(TYPE.USE_GUIDE.PRIVACY, privacyDrop.id[opt])

  //       // 변경
  //       getTermDetail(finDate)

  //       break

  //     default:
  //       break
  //   }
  // }

  return (
    <>
      {loading ? (
        <Loading />
      ) : data?.responseData ? (
        isTermAgree ? (
          //동의 후 이용약관 페이지 URL 접근시 홈 이동
          navigate('/')
        ) : (
          <UseGuideWrap>
            {/*{(user.agreementTermsYn == 'Y')? (*/}
            <>
              <SignOutImg src={CloseImg} onClick={signOut} />

              <NoClick>
                <HeaderTab
                  isDesktop={true}
                  headerItem={['이용약관']}
                  selectedItem={selectedTab}
                  handleItem={(idx) => setSelectedTab(idx)}
                />
              </NoClick>

              <Terms
                privacyItem={privacyItem}
                serviceItem={serviceItem}
                ageItem={ageItem}
                activeTerms={activeTerms}
                isAgree={termsAgree.complete}
                agreementTime={
                  termsAgree.agreementTime
                    ? moment(termsAgree.agreementTime).format('YY년 MM월 DD일')
                    : null
                }
                termsAgree={termsAgree}
                handleArrow={handleArrow}
                handleCheck={handleCheck}
                handleAgree={handleAgree}
              />
            </>
          </UseGuideWrap>
        )
      ) : (
        navigate('/error')
      )}
    </>
  )
}

export default UseGuide

const UseGuideWrap = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`
const NoClick = styled.div`
  pointer-events: none;
`
const SignOutImg = styled.img`
  float: right;
  margin-right: 15px;
`
